import React, { useEffect } from "react";
import { Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { useHubSnackBar, usePostCreateLabor } from "../../hooks";
import {
  HubCancelSubmitGroup,
  HubDialogContent,
  HubHookFormWrapper,
} from "../../components";

import { useDialogContext } from "../HubDialogWrapper";
import CreateLaborForm from "./CreateLaborForm";

export const CreateLaborContent = () => {
  const navigate = useNavigate();

  const { addSnackbarSuccess, addSnackbarInfo } = useHubSnackBar();
  const { onClose = () => {}, open } = useDialogContext();
  const { workOrder, rid } = open;

  const {
    data,
    isLoading,
    isSuccess,
    mutate: postCreateLabor,
  } = usePostCreateLabor();

  useEffect(() => {
    if (isSuccess) {
      if (data?.ticketId) {
        addSnackbarInfo({ message: "Labor ticket already exists" });
        navigate(`/labor/${data?.ticketId}`);
      } else
        addSnackbarSuccess({ message: "Labor Ticket Created Successfully" });
      onClose();
    }
  }, [data, isSuccess]);

  const onSubmit = (formData) => {
    const userId = Number(formData.userId);
    const routingId = Number(formData.routingId);

    const payload = { routingId, userId };
    postCreateLabor(payload);
  };

  return (
    <HubDialogContent largePadding>
      <HubHookFormWrapper onSubmit={onSubmit}>
        <Stack gap="35px">
          <Stack gap="10px" alignItems="center">
            <Typography variant="h6">Create a New Labor Ticket</Typography>
            <Typography
              variant="caption"
              sx={{ textAlign: "center", maxWidth: "450px" }}
            >
              You are about to create a new labor ticket for work order with a
              start time of when the ticket is created. Select the routing you
              are about to work on and enter your employee ID to continue.
            </Typography>
          </Stack>
          <Stack gap="15px" width="100%" alignItems="center">
            <CreateLaborForm
              workOrder={workOrder}
              rid={rid}
              onClose={onClose}
            />
            <HubCancelSubmitGroup
              disabled={isLoading}
              isLoading={isLoading}
              label="Create Ticket"
              overrideCancel={onClose}
            />
          </Stack>
        </Stack>
      </HubHookFormWrapper>
    </HubDialogContent>
  );
};

export default CreateLaborContent;
